import React, { useEffect, useState } from "react";
import DescriptionDetails from "../../components/description-details";
import StepContent from "../../components/step-content";
import {StructuredListSkeleton, Column, Row, Button } from 'carbon-components-react';
import {Edit16 } from '@carbon/icons-react';
import { formatDate } from "../../components/formatters";
import EmployeeEdit from "./employee-edit";
import { useSelector } from "react-redux";
import { EnrollmentType } from "../../components/enums/enrollment-type";
import * as Yup from "yup";
import { OptionalString, RequiredDate, RequiredString } from "../../components/form_elements/form-validators";
import EmployeeValidation from "./employee-validation";

const Employee = ({ pageStep }) => {
  const [employee, setEmployee] = useState();
  const [show, setShow] = useState();
  const enrollments = useSelector(s => s.enrollments);
  const [isEditable, setIsEditable] = useState();

  useEffect(() => {   
    if(Array.isArray(enrollments))
      return;
    
    setEmployee(enrollments.employee);
    if(enrollments.enrollmentTypeId === EnrollmentType.NewHire)
      setIsEditable(true);

  }, [enrollments]);

  const maskSsn = (ssn) => {
    var ssnShow = ssn?.substr(ssn.length - 4);
    var ssnHidden = ssn?.substr(0, ssn.length - 4).replace(/[0-9]/g, "*");
    return ssnHidden + ssnShow;;
  }
  const validationSchema = Yup.object().shape({
    firstName: RequiredString("Required"),
    lastName:  RequiredString("Required"),
    birthdate: RequiredDate("Required").max(new Date(), 'Invalid Date').min(new Date(1920,0,1), 'Must be later than 1/1/1920'),
    ssn:  RequiredString("Required").test("", "SSN must be 9 digits", (item) => item ? item.length === 11 : true)
        .test("", "Not a valid SSN", (item) =>  item ? /^(?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4})$/.test(item) : true)
        .test("", "Not a valid SSN", (item) =>  item ? item !== "123-45-6789" : true),
    maritalStatusId:  RequiredString("Required"),
    genderId:  RequiredString("Required"),
    addressLine1:  RequiredString("Required"),
    addressLine2:  OptionalString("Required"),
    city:  RequiredString("Required"),
    state:OptionalString().test("", "Required", (item, ctx) => { 
        return ctx.parent.country === "US" && (item === null || item === "") ? false : true
    }),
    region:OptionalString("Required").test("", "Required", (item, ctx) => { 
        return ctx.parent.country !== "US" && (item === null || item === "") ? false : true
    }),
    postalCode:  RequiredString("Required"),
    country:  RequiredString("Required"),

  });

  const onSubmit = async (formData) => {
    console.log(formData);
  };

  const onEdit = async () => {
    setShow(true);
  }


  const buildAddress = (employee) => {
    return(<>
        {employee?.addressLine1 ? 
            <span>{employee.addressLine1}<br /> 
            {employee.addressLine2 ? <>{employee?.addressLine2} <br /></> : <></>}
            {employee.city},&nbsp;
            {employee.country === "US" ?
            <>{employee.state}</> : <>{employee.region}</>} {employee.postalCode}
            {employee.country === "US" ? <></> : <><br />{employee.country}</>}
            </span>
             :
            <></>
        }
        </>
    );
}

  return (
    <>
      <StepContent
        pageStep={pageStep}
        onSubmit={onSubmit}
        schema={validationSchema}
      >
        <Row>
          <Column md={8} lg={5}>
          <div className='grid grid-cols-2 items-center mb-4 mt-2'>
            <div className='text-3xl'>
            <Button kind='ghost' size='sm' renderIcon={Edit16} iconDescription="Edit" onClick={() => setShow(true)}></Button>
              Employee
            </div>
        </div>
            {employee ? 
              <div className="pl-4 space-y-4">
                <DescriptionDetails term="Legal First Name" definition={employee.firstName} editable={isEditable} onEdit={onEdit} />
                <DescriptionDetails term="Legal Last Name" definition={employee.lastName} editable={isEditable} onEdit={onEdit} />
                <DescriptionDetails term="Social Security Number" definition={maskSsn(employee.ssn)} editable={isEditable} onEdit={onEdit} />
                <DescriptionDetails term="Date of Birth" definition={formatDate(employee.birthdate)} editable={isEditable} onEdit={onEdit} />
                <DescriptionDetails term="Address" definition={buildAddress(employee)}  editable={true} onEdit={onEdit}/>
                <DescriptionDetails term="Gender" definition={employee.gender?.name} editable={true} onEdit={onEdit} />
                <DescriptionDetails term="Marital Status" definition={employee.maritalStatus?.name} editable={true} onEdit={onEdit} />
                <EmployeeValidation />
              </div>
            : 
              <div className="my-8">
                <StructuredListSkeleton />
              </div>
            }
          </Column>
        </Row>
      </StepContent>
      <EmployeeEdit 
        employee={employee} 
        show={show} 
        setShow={setShow} 
      />

    </>
  );
};

export default Employee;
